import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { WeekDaysOptions } from '../../../constants/options.constant';
import IAddEditWeekendHolidays from '../../../models/forms/IAddEditWeekendHoliday';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import { WeekendCalendarValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { formatMessage } from '../../../translations/format-message';

registerLocale('en-IN', enIN);

interface IProps extends IAddEditFormProps<any> {
  selectedYear: number;
}
const AddEditWeekendForm = (props: IProps) => {
  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        validationSchema={WeekendCalendarValidationSchema}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (
          values: IAddEditWeekendHolidays,
          { resetForm, setFieldValue }
        ) => {
          props.submitHandler(values);
        }}
      >
        {() => {
          return (
            <FormikForm className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} />
              ) : null}
              <Form.Group controlId="dateRange">
                <Form.Group
                  className="mb-3"
                  controlId="date"
                >
                  <Label
                    className="label-style col-form-label"
                    required={true}
                    label="weekend_1"
                  />
                  <Field
                    name="Weekend_1"
                    as={FormikFormSelect}
                    options={WeekDaysOptions}
                    setDefaultValue={true}
                    className="form-control"
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  controlId="date"
                >
                  <Label
                    className="label-style col-form-label"
                    required={true}
                    label="weekend_2"
                  />
                  <Field
                    name="Weekend_2"
                    as={FormikFormSelect}
                    options={WeekDaysOptions}
                    setDefaultValue={true}
                    className="form-control"
                  />
                </Form.Group>
              </Form.Group>
              <div className="text-end">
                <Button
                  variant="primary"
                  type="submit"
                  className=""
                >
                  {formatMessage('save')}
                </Button>
              </div>
            </FormikForm>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default AddEditWeekendForm;
